export const RiverIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 15.412C4.77485 15.412 6.856 12.0591 6.856 12.0591C6.856 12.0591 8.93714 15.412 11.712 15.412C14.4868 15.412 17.2617 12.0591 17.2617 12.0591C17.2617 12.0591 20.0365 15.412 22.1177 15.412"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 20.9999C4.77485 20.9999 6.856 17.647 6.856 17.647C6.856 17.647 8.93714 20.9999 11.712 20.9999C14.4868 20.9999 17.2617 17.647 17.2617 17.647C17.2617 17.647 20.0365 20.9999 22.1177 20.9999"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.8824 9.82355C19.8824 5.50272 16.3797 2 12.0589 2C7.73808 2 4.23535 5.50272 4.23535 9.82355"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
